import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { throwError, Observable } from 'rxjs';

import { HttpClientService } from 'lib/ng2-sapmp/src/providers';

@Injectable()
export class ContactService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService) { }

  getContactDetails(getContactDetailsservice) {
      return this.httpClientService.get(getContactDetailsservice)
      .pipe(
       map((test: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(test.body);
        return test.body;
      })
      ,catchError( this.handleError ));
  }

  handleError = (error) => {
    return throwError(error);
  }
}

